/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { LabelWrapper } from './styledComponents.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';
import componentWithName from '../../prop-types/componentWithName.js';

var _excluded = ["children", "customStyle", "htmlFor", "isDisabled", "showPointer", "tooltip"];
var Label = function Label(_ref) {
  var children = _ref.children,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === undefined ? {
      labelStyle: {}
    } : _ref$customStyle,
    htmlFor = _ref.htmlFor,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
    _ref$showPointer = _ref.showPointer,
    showPointer = _ref$showPointer === undefined ? false : _ref$showPointer,
    tooltip = _ref.tooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    labelStyle = _safeCustomStyle.labelStyle;
  return /*#__PURE__*/jsxs(LabelWrapper, _objectSpread(_objectSpread({
    htmlFor: htmlFor,
    labelStyle: labelStyle,
    theme: theme,
    isDisabled: isDisabled,
    showPointer: showPointer
  }, safeProps), {}, {
    children: [children, tooltip && /*#__PURE__*/jsx("span", {
      className: "mux-Label-Tooltip",
      children: tooltip
    })]
  }));
};
process.env.NODE_ENV !== "production" ? Label.propTypes = {
  /** Content for the legend */
  children: PropTypes.node.isRequired,
  /** Style overrides */
  customStyle: PropTypes.shape({
    labelStyle: PropTypes.object
  }),
  /** id of element that the label is bound to */
  htmlFor: PropTypes.string,
  /** Flag to show disabled state styling (overrides showPointer) */
  isDisabled: PropTypes.bool,
  /** Flag to show pointer (useful when using labels with TextInput) */
  showPointer: PropTypes.bool,
  /** [Tooltip](/docs/tooltip) displayed beside the label */
  tooltip: componentWithName('Tooltip')
} : undefined;
process.env.NODE_ENV !== "production" ? Label.displayName = 'Label' : undefined;

export { Label as default };
